// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 337 ? "6e5c0b69" : chunkId) + "." + {"337":"0b3affbc60239c97","1213":"2827fa66845b6fd1","4487":"23a60e1a210d9dd7","4857":"bfa0a7676588b789","5811":"3a151cfc6164abe7"}[chunkId] + ".js";
};